import React, { createContext, useState, useEffect, useContext } from 'react';
import { getCurrentUser, logout } from '../utils/api';
import { logoutMicrosoft } from '../utils/msalClient';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      if (window.location.pathname === '/auth/callback') {
        setLoading(false);
        return;
      }

      // Check if user is stored in localStorage
      const storedUser = localStorage.getItem('currentUser');
      
      if (storedUser) {
        setCurrentUser(JSON.parse(storedUser));
      }
      
      try {
        // Verify with the server
        const response = await getCurrentUser();
        if (response.success) {
          setCurrentUser(response.user);
          localStorage.setItem('currentUser', JSON.stringify(response.user));
        } else {
          // If server says user is not logged in, clear local storage
          setCurrentUser(null);
          localStorage.removeItem('currentUser');
        }
      } catch (error) {
        console.error('Error getting current user:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      setCurrentUser(null);
      localStorage.removeItem('currentUser');
      // Clear selected project on logout
      localStorage.removeItem('selectedProject');
      await logoutMicrosoft();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const value = {
    currentUser,
    setCurrentUser,
    logout: handleLogout,
    isAuthenticated: !!currentUser,
    isAdmin: currentUser?.role === 'admin',
    isManager: currentUser?.role === 'manager',
    loading,
    isLoading: loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
